export function setSessionExpired() {
  return { type: "USER_SESSION_EXPIRED" }
}

export function setLanguageId(languageId) {
  return { type: "SET_LANGUAGE", languageId }
}

export function setUserDetails(authenticated, user) {
  return {
    type: "SET_USER_DETAILS",
    authenticated,
    user,
  }
}



// WEBPACK FOOTER //
// ./src/state/actions/userDetailActions.js